import { Link, useLocation } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { useAuth } from '@/lib/auth/AuthContext'
import { cn } from '@/lib/utils'

const navItems = [
  { href: '/', label: 'Events' },
  { href: '/event-operations', label: 'Event Ops' },
  { href: '/infra', label: 'Infrastructure' },
  { href: '/queues', label: 'Queues' },
  { href: '/subscribers', label: 'Subscribers' },
  { href: '/clubroom-gifs', label: 'Clubroom Images' },
  { href: '/match-metrics', label: 'Match Metrics' },
  { href: '/simulations', label: 'Simulations' },
  { href: '/cleanUserId', label: 'Clean UserId' }
]

export function MainNav() {
  const location = useLocation()
  const { isAuthenticated, isLoading, logout, signIn } = useAuth()

  const handleSignIn = () => {
    if (typeof window !== 'undefined') {
      sessionStorage.setItem('redirectAfterLogin', location.pathname || '/')
    }
    signIn()
  }

  return (
    <div className="flex w-full flex-wrap items-center justify-between gap-4">
      <nav className="flex flex-1 flex-wrap items-center gap-6 text-sm font-semibold text-slate-200">
        {navItems.map((item) => {
          const isActive =
            location.pathname === item.href ||
            (item.href !== '/' && location.pathname.startsWith(item.href))

          return (
            <Link
              key={item.href}
              to={item.href}
              className={cn(
                'transition-colors hover:text-accent',
                isActive ? 'text-accent' : 'text-slate-400'
              )}
            >
              {item.label}
            </Link>
          )
        })}
      </nav>

      <div className="ml-auto flex items-center gap-3">
        {isLoading ? (
          <Button variant="ghost" className="text-slate-400" disabled>
            <span className="mr-2 h-2.5 w-2.5 animate-pulse rounded-full bg-accent" />
            Loading…
          </Button>
        ) : isAuthenticated ? (
          <Button
            variant="secondary"
            className="bg-slate-800 text-slate-100 hover:bg-slate-700"
            onClick={() => logout()}
          >
            Sign Out
          </Button>
        ) : (
          <Button onClick={handleSignIn}>
            Sign In
          </Button>
        )}
      </div>
    </div>
  )
}
